// Título de item pai do menu (desktop) navega; só a seta abre o submenu.
// Um <a> dentro de um <summary> navega E alterna o <details>; parar a
// propagação na fase de captura impede que o clique chegue ao <summary>,
// então o submenu não pisca antes de a navegação acontecer.
document.addEventListener(
  'click',
  (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (target && target.closest('a[data-parent-link]')) event.stopPropagation();
  },
  true
);
